import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useMediaQuery } from '@mui/system'
import BusinessAppointments from '../../Components/BusinessUser/BusinessAppointments/BusinessAppointments'
import BusinessEmployeeList from '../../Components/BusinessUser/BusinessEmployee/BusinessEmployeeList'
import CustomerRouteAccess from './CustomerRouteAccess'
import CustomerSidebar from '../../Container/CustomerUser/CustomerSidebar'
import CustomerBooking from '../../Components/CustomerUser/CustomerBookService'
import CustomerAppointments from '../../Container/CustomerUser/CustomerAppointments'
import Properties from '../../Components/CustomerUser/Properties/Properties'
import PropertyDetails from '../../Components/CustomerUser/Properties/PropertyDetails'
import CustomerProfile from '../../Components/CustomerUser/CustomerProfile'


const CustomerRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");

  return (
    <div>
          <div>
      <CustomerSidebar />
      <div style={{ marginLeft: isLargeScreen ? '250px' : '0', flexGrow: 1, padding: "10px" }}>

      <Routes>
          <Route path="/book-service" element={<CustomerRouteAccess element={<CustomerBooking />} />}/>
          <Route path="/my-service" element={<CustomerRouteAccess element={<CustomerAppointments />} />}/>
          <Route path="/my-profile" element={<CustomerRouteAccess element={<CustomerProfile/>} />}/>
          <Route path="/my-properties" element={<CustomerRouteAccess element={<Properties/>} />}/>
          <Route path="/property-details/:id" element={<CustomerRouteAccess element={<PropertyDetails/>} />}/>
          {/* <Route path="/employees" element={<BusinessRouteAccess element={<EmployeesList/>} />}/> */}
      </Routes>
    </div>
    </div>
    </div>
  )
}

export default CustomerRoutes